export default [
  { label: "Public", value: "t" },
  { label: "Private (Me)", value: "f" }
]
